import React from 'react';
import Button from '@mui/material/Button';
import PhoneIcon from '@mui/icons-material/Phone';
import { asyncLogParams } from '../components-logging/firebaseManager';

const ContactSalesButton = () => {
  const contactSalesLink = 'https://www.azahner.com/products/imagewall/contact'; 

  const handleContactSalesClick = () => {
    asyncLogParams("contactSales", 1, contactSalesLink);
    window.open(contactSalesLink, '_blank'); // Open the link in a new tab
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<PhoneIcon />}
      onClick={handleContactSalesClick}
    >
      Get a Quote
    </Button>
  );
};

export default ContactSalesButton;

